<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <div>
            {{ title }}
          </div>
        </div>
        <div class="modal_body">
          <div class="body">
            <div class="oldPassword">
              <div class="label">
                {{ oldPassword }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                type="password"
                id="oldPassword"
                v-model="oldPasswordInput"
              />
            </div>
            <div class="newPassword">
              <div class="label">
                {{ newPassword }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                type="password"
                id="newPassword"
                v-model="newPasswordInput"
              />
            </div>
            <div class="confirmPassword">
              <div class="label">
                {{ confirmPassword }}
                <div class="require_items_label">
                  {{ requiredItemLabel }}
                </div>
              </div>
              <input
                type="password"
                id="confirmPassword"
                v-model="confirmPasswordInput"
              />
            </div>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="changeButton"
              class="finish_button"
              @click="showConfirmPasswordModal = true"
            />
          </div>
          <div class="modal_window" v-if="showConfirmPasswordModal">
            <confirmPasswordModalWindow
              :question="changeWord"
              @close="close"
              @ok="matching"
            >
            </confirmPasswordModalWindow>
          </div>
          <div class="complete_modal_window" v-if="showCompleteModal">
            <finishModalWindow :question="completeWord" @close="close">
            </finishModalWindow>
          </div>
          <div class="modal_window" v-if="showFailureModal">
            <finishModalWindow :question="failureWord" @close="stayClose">
            </finishModalWindow>
          </div>
          <div class="loading_modal_window" v-if="showloadingModal">
            <loadingModalWindow @close="close"> </loadingModalWindow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import confirmPasswordModalWindow from './confirmModalWindow.vue'
import finishModalWindow from './finishModalWindow.vue'
import loadingModalWindow from './loadingModalWindow.vue'

export default {
  props: ['deleteList', 'mode'],
  data() {
    return {
      title: 'パスワード変更',
      oldPassword: '現在のパスワード :',
      oldPasswordInput: '',
      newPassword: '新しいパスワード :',
      newPasswordInput: '',
      confirmPassword: '新しいパスワードの確認 :',
      confirmPasswordInput: '',
      changeWord: 'パスワードを変更しますか？',
      notMatchPassword: '',
      failureWord: '',
      cancelButton: 'キャンセル',
      changeButton: '変更',
      showConfirmPasswordModal: false,
      showNotMatchPasswordModal: false,
      showCompleteModal: false,
      showFailureModal: false,
      showloadingModal: false
    }
  },
  components: {
    confirmPasswordModalWindow,
    finishModalWindow,
    loadingModalWindow
  },
  computed: {
    backgroundColor() {
      if (
        this.showCompleteModal === true ||
        this.showConfirmPasswordModal === true ||
        this.showFailureModal === true
      ) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  methods: {
    close(e) {
      this.$emit('close')
    },
    stayClose(e) {
      this.showFailureModal = false
    },
    async matching(e) {
      this.showloadingModal = true
      this.showConfirmPasswordModal = false
      var newPassword = this.newPasswordInput
      var confirmPassword = this.confirmPasswordInput
      var oldPassword = this.oldPasswordInput
      if (newPassword === '' || confirmPassword === '') {
        this.failureWord =
          this.errorMsg.MSGCRC0095.name + this.errorMsg.MSGCRC0095.value
        this.showFailureModal = true
      } else if (newPassword !== confirmPassword) {
        this.failureWord =
          this.errorMsg.MSGCRC0090.name + this.errorMsg.MSGCRC0090.value
        this.showFailureModal = true
      } else {
        // パスワード更新のコードを追記
        if (this.mode === 'adminAccount') {
          try {
            await this.$store.dispatch('adminAccounts/changePassword', {
              previousPassword: this.oldPasswordInput,
              newPassword: this.newPasswordInput
            })
            this.completeWord = 'パスワードを変更しました。'
            this.showCompleteModal = true
          } catch (error) {
            let eventNumber = this.$store.state.error.errorCode.errorCode_310005
            let eventType = 3
            let reason = ''
            if (
              error.response &&
              error.response.data &&
              error.response.data.header &&
              error.response.data.header.message
            ) {
              let errorMessage = error.response.data.header.message
              if (errorMessage === 'MSGCRC0013') {
                this.failureWord =
                  this.errorMsg.MSGCRC0013.name +
                  this.errorMsg.MSGCRC0013.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage === 'MSGCRC0091') {
                this.failureWord =
                  this.errorMsg.MSGCRC0091.name +
                  this.errorMsg.MSGCRC0091.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage === 'MSGCRC0112') {
                this.failureWord =
                  this.errorMsg.MSGCRC0112.name +
                  this.errorMsg.MSGCRC0112.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else if (errorMessage === 'MSGCRC0125') {
                this.failureWord =
                  this.errorMsg.MSGCRC0125.name +
                  this.errorMsg.MSGCRC0125.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              } else {
                this.failureWord =
                  this.errorMsg.MSGCRC0012.name +
                  this.errorMsg.MSGCRC0012.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              }
              reason = errorMessage + ' '
              reason += error.response.status
            } else if (error.response && error.response.data) {
              reason = 'MSGCRC0012'
              eventType = 9
              this.failureWord =
                this.errorMsg.MSGCRC0012.name +
                this.errorMsg.MSGCRC0012.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            } else {
              reason = 'MSGCRC0005'
              eventType = 9
              this.failureWord =
                this.errorMsg.MSGCRC0005.name +
                this.errorMsg.MSGCRC0005.value +
                'エラーコード：{' +
                eventNumber +
                '}'
            }
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.showFailureModal = true
          }
        } else if (this.mode === 'master') {
          if (
            this.$store.state.masters.logoutFlagMaster.initLoginPassword ===
            oldPassword
          ) {
            try {
              await this.$store.dispatch('masters/changePassword', newPassword)
              this.completeWord = 'パスワードを変更しました。'
              this.showCompleteModal = true
            } catch (error) {
              let eventNumber = this.$store.state.error.errorCode
                .errorCode_430004
              let eventType = 3
              let reason = ''
              if (
                error.response &&
                error.response.data &&
                error.response.data.header &&
                error.response.data.header.message
              ) {
                let errorMessage = error.response.data.header.message
                if (errorMessage === 'MSGCRC0091') {
                  this.failureWord =
                    this.errorMsg.MSGCRC0091.name +
                    this.errorMsg.MSGCRC0091.value +
                    'エラーコード：{' +
                    eventNumber +
                    '}'
                } else if (errorMessage === 'MSGCRC0197') {
                  this.failureWord =
                    this.errorMsg.MSGCRC0197.name +
                    this.errorMsg.MSGCRC0197.value +
                    'エラーコード：{' +
                    eventNumber +
                    '}'
                } else if (errorMessage === 'MSGCRC0125') {
                  this.failureWord =
                    this.errorMsg.MSGCRC0125.name +
                    this.errorMsg.MSGCRC0125.value +
                    'エラーコード：{' +
                    eventNumber +
                    '}'
                } else if (errorMessage === 'MSGCRC0135') {
                  this.failureWord =
                    this.errorMsg.MSGCRC0135.name +
                    this.errorMsg.MSGCRC0135.value +
                    'エラーコード：{' +
                    eventNumber +
                    '}'
                } else if (errorMessage === 'MSGCRC0136') {
                  this.failureWord =
                    this.errorMsg.MSGCRC0136.name +
                    this.errorMsg.MSGCRC0136.value +
                    'エラーコード：{' +
                    eventNumber +
                    '}'
                } else {
                  this.failureWord =
                    this.errorMsg.MSGCRC0012.name +
                    this.errorMsg.MSGCRC0012.value +
                    'エラーコード：{' +
                    eventNumber +
                    '}'
                }
                reason = errorMessage + ' '
                reason += error.response.status
              } else {
                reason = 'MSGCRC0005'
                eventType = 9
                this.failureWord =
                  this.errorMsg.MSGCRC0005.name +
                  this.errorMsg.MSGCRC0005.value +
                  'エラーコード：{' +
                  eventNumber +
                  '}'
              }
              try {
                this.$store.dispatch('masters/writeLog', {
                  eventNumber,
                  eventType,
                  reason
                })
              } catch (error) {}
              this.showFailureModal = true
            }
          } else {
            let eventNumber = this.$store.state.error.errorCode.errorCode_430005
            let eventType = 9
            let reason = 'MSGCRC0013'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.failureWord =
              this.errorMsg.MSGCRC0013.name +
              this.errorMsg.MSGCRC0013.value +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showFailureModal = true
          }
        } else {
        }
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.container {
  display: table-cell;
  vertical-align: middle;
}
.modal_container {
  width: 435px;
  height: 380px;
}
.modal_header {
  display: table;
  width: 100%;
}
.modal_header div {
  padding-left: 14px;
  display: table-cell;
  vertical-align: middle;
}
.modal_body {
  height: 332px;
}
.body {
  height: 262px;
  padding-top: 40px;
}
.require_items_label {
  margin-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/changePasswordModalWindow.vue